import { Facebook, Star } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const FACEBOOK_URL =
  "https://www.facebook.com/share/1CVqa1Uwox/?mibextid=wwXIfr";

export default function Testimonials() {
  return (
    <section
      id="reviews"
      data-testid="testimonials-section"
      className="mx-auto max-w-5xl px-4 py-24 sm:px-8 md:py-32 lg:px-16"
    >
      <SectionHeading
        overline="03 / From the field"
        title="What folks say."
        testid="testimonials-heading"
      />
      <Reveal>
        <figure
          data-testid="testimonial-card-1"
          className="glow-card rounded-md border border-[#1c4431]/15 bg-[#faf6ea] p-8 text-center md:p-14"
        >
          <div
            data-testid="testimonial-stars"
            className="flex items-center justify-center gap-1.5"
          >
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                className="h-6 w-6 fill-[#1f5c3d] text-[#1f5c3d]"
              />
            ))}
          </div>
          <blockquote
            data-testid="testimonial-quote"
            className="mx-auto mt-8 max-w-3xl font-display text-xl font-bold leading-snug tracking-tight text-[#1a2e22] sm:text-2xl md:text-3xl"
          >
            "So glad I called Colby! He was so nice, knowledgeable and
            respectful. Not to mention the price was very reasonable. I am one
            very satisfied customer — couldn't recommend enough!"
          </blockquote>
          <figcaption className="mt-8">
            <span
              data-testid="testimonial-author"
              className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-[#1f5c3d]"
            >
              Lamanda Mccoy
            </span>
            <span className="mt-2 block font-mono text-[10px] uppercase tracking-[0.25em] text-[#8a9481]">
              5-star Facebook review · July 19, 2025
            </span>
          </figcaption>
          <a
            data-testid="testimonial-facebook-link"
            href={FACEBOOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center gap-2 rounded-full border border-[#1c4431]/25 px-6 py-3 font-mono text-xs font-bold uppercase tracking-widest text-[#1f5c3d] transition-colors duration-300 hover:bg-[#1f5c3d] hover:text-[#f6f1e3]"
          >
            <Facebook className="h-4 w-4" />
            Read it on Facebook
          </a>
        </figure>
      </Reveal>
    </section>
  );
}
